import { MenuItem, MenuItemProps } from "@mui/material";

import { useAnalytics } from "@/providers";
import {
  ComponentPropsWithEvent,
  EventName,
} from "@/shared/services/analytics";

type RobotoMenuItemProps<T extends EventName> = ComponentPropsWithEvent<
  T,
  MenuItemProps
>;

export function RobotoMenuItem<T extends EventName>(
  props: RobotoMenuItemProps<T>,
): JSX.Element;

export function RobotoMenuItem(props: Partial<RobotoMenuItemProps<EventName>>) {
  const { trackEvent } = useAnalytics();

  const { eventName, eventProperties, onClick, ...filteredProps } = props;

  return (
    <MenuItem
      {...filteredProps}
      onClick={(e) => {
        if (eventName) {
          trackEvent(eventName, eventProperties);
        }
        onClick?.(e);
      }}
    >
      {props.children}
    </MenuItem>
  );
}
